import { FormControlLabel, Checkbox } from "@mui/material";
import StyledBadge from "../../styledBadge/StyledBadge";

const FilterCheckbox = ({
  badgeContent,
  onClickHandler,
  label,
  checked,
  disabled,
}: {
  badgeContent: number;
  onClickHandler: () => void;
  label: string;
  checked: boolean;
  disabled?: boolean;
}): React.JSX.Element => {
  return (
    <StyledBadge
      max={9999}
      showZero
      sx={{ pr: 1, mr: 4 }}
      badgeContent={badgeContent}
      color="secondary"
    >
      <FormControlLabel
        control={
          <Checkbox
            onClick={onClickHandler}
            checked={checked}
            disabled={disabled}
          />
        }
        label={label}
      />
    </StyledBadge>
  );
};

export default FilterCheckbox;
